import React, { Component } from 'react';
import { FormGroup, Row, Col, Label, Input } from 'reactstrap';

export default class Contracts extends Component {
    constructor(props) {
        super(props)

        this.state = {

        };
    }

    render() {
        return (
            <div>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Name</Label>
                            <Input name='name' required maxLength="100" value={this.props.item.name || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col sm='12'>
                        <FormGroup>
                            <Label>Description</Label>
                            <Input type="textarea" name='description' maxLength="1000" required value={this.props.item.description || ''} onChange={this.props.onChange} />
                        </FormGroup>
                    </Col>
                </Row>
            </div>
        )
    }
}